import httpClient from '@/apis/base/httpclient';
import BaseAPI from '@/apis/base/baseApi';

class LayoutApi extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'layout';

	/**
	 * Lấy layout đang sử dụng
	 */
	 getApply(code) {
		let request = {
            url: [this.getAPIUrl(), '/apply/', code].join(''),
		};

		return httpClient.getAsync(request);
	}

	/**
	 * Lấy layout mặc định
	 */
	getDefault(code) {
		let request = {
            url: [this.getAPIUrl(), '/default/', code].join(''),
		};

		return httpClient.getAsync(request);
	}
}

export default new LayoutApi();
